//Loading que se mustra en toda la app
import React from 'react'
import '../spinner.css'

const Spinner = ({ title }) => {
    return (
        <div className={` ${title ? ' flex justify-center items-center flex-col ' : 'flex justify-center items-center'}`}>
            <div className="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
            {
                title && (<span className='mt-6 text-lg font-medium text-[#09101F] '> {title} </span>)
            }
        </div>
    )
}

export default Spinner